import React, { useState } from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro1/Intro.jsx';
import Content from '../../components/user/sub4_2/Content.jsx';
import Footer from '../../components/user/footer/Footer.jsx';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub4_2() {
  // 현재 활성화된 카테고리 상태 (첫 번째 탭을 기본값으로)
  const [activeCategory, setActiveCategory] = useState('식당');

  // 카테고리 변경 핸들러
  const onCategoryChange = (category, index) => {
    setActiveCategory(category);
    console.log('카테고리 변경:', category, index);
    // 여기서 Content 컴포넌트에 카테고리 변경을 알리거나 API 호출 등을 할 수 있습니다
  };

  // 메뉴 아이템 데이터 - 이미지의 7개 탭
  const menuItems = [
    {
      title: '식당',
      category: '식당',
    },
    {
      title: '뷔페',
      category: '뷔페',
    },
    {
      title: '카페베이커리',
      category: '카페베이커리',
    },
    {
      title: '스크린골프',
      category: '스크린골프',
    },
    {
      title: '병원',
      category: '병원',
    },
    {
      title: '호텔',
      category: '호텔',
    },
    {
      title: '기타',
      category: '기타',
    },
  ];

  return (
    <>
      <Header />
      <SubIntro
        mainTitle="청소로봇"
        subTitle="크림봇을 사용하신 고객분들의 이야기를 확인해보세요"
        menuItems={menuItems}
        activeCategory={activeCategory}
        onCategoryChange={onCategoryChange}
        isTabMode={true}
      />
      <Content activeCategory={activeCategory} />
      <Footer />
    </>
  );
}
